import router from "./router";
import { getToken, getRouters } from "./utils/auth";
import { isMobile } from "./utils/public";
import store from "./store";

/** 无需登录、不注入动态路由（海康 OAuth 回跳必须放行） */
const PUBLIC_PATHS = ["/login", "/error", "/hikAuthCallback", "/mobile/monitor"];
const PUBLIC_ROUTE_NAMES = ["ErrorPage", "HikAuthCallback", "MobileMonitorPlay"];

function normalizePath(path) {
  if (!path) {
    return "/";
  }
  const trimmed = path.replace(/\/+$/, "");
  return trimmed || "/";
}

function isPublicRoute(to) {
  const path = normalizePath(to.path);
  if (PUBLIC_PATHS.includes(path)) {
    return true;
  }
  if (to.name && PUBLIC_ROUTE_NAMES.includes(String(to.name))) {
    return true;
  }
  return false;
}

/*
 * 判断是否cook里的token是否有效
 * 如果有效则继续跳转到访问页面
 * 无效则跳转至登录页面
 * */

router.beforeEach(async function (to, from, next) {
  try {
    if (isPublicRoute(to)) {
      next();
      return;
    }

    const jumpPath = normalizePath(to.path);
    if (!getToken()) {
      next("/login");
      return;
    }

    if (!store.getters.routeFlag) {
      const routerArr = getRouters();
      if (!routerArr.length) {
        next({
          name: "ErrorPage",
          params: { errorType: "您没有访问权限，请联系管理员" }
        });
        return;
      }
      routerArr.forEach((route) => {
        router.addRoute(route);
      });
      store.dispatch("user/setRouteFlag", true);
    }

    if (to.matched.length === 0 && jumpPath !== "/") {
      next("/");
      return;
    }

    if (jumpPath === "/") {
      let defaultUrl = store.getters.userInfo.firstPath;
      if (isMobile() && defaultUrl && defaultUrl.jump) {
        defaultUrl = `/mobile/${defaultUrl.jump}`;
      }
      next(defaultUrl);
      return;
    }

    next();
  } catch (e) {
    console.error("[router beforeEach]", e);
    next("/error");
  }
});
